import React from "react";
import { BrowserRouter as Router, Route, Routes, Navigate, useLocation } from "react-router-dom";
import Register from "./Auth_Pages/Register";
import Login from "./Auth_Pages/Login";
import Logout from "./Auth_Pages/Logout";
import { AuthProvider } from "./Context/AuthContext";
import Dashboard from "./components/Dashboard";
import Home from "./components/Home";
import NotFound from "./components/NotFound";
import Header from "./components/Header";
import Footer from "./components/Footer";
import Gmail from "./Gmail/Gmail";

const App = () => {
  const location = useLocation();
  const showHeaderFooter = !["/login", "/register"].includes(location.pathname);

  return (
    <div>
      {showHeaderFooter && <Header />}
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/register" element={<Register />} />
        <Route path="/login" element={<Login />} />
        <Route path="/logout" element={<Logout />} />
        <Route path="/mails" element={<Gmail />} />
        <Route path="/dashboard" element={<Dashboard />} />
        <Route path="*" element={<Navigate to="/not-found" replace />} />
        <Route path="/not-found" element={<NotFound />} />
      </Routes>
      {showHeaderFooter && <Footer />}
    </div>
  );
};

const AppWrapper = () => (
  <Router>
    <AuthProvider>
      <App />
    </AuthProvider>
  </Router>
);

export default AppWrapper;
